/**
 * @returns true if plan has setup fee.
 */
export const hasSetupFee = plan => {
  var _plan$pricing;
  return Boolean((_plan$pricing = plan.pricing) == null || (_plan$pricing = _plan$pricing.feeConfigs) == null || (_plan$pricing = _plan$pricing[0]) == null ? void 0 : _plan$pricing.fee);
};

/**
 * @returns setup fee name or undefined if setup fee doesn't exist
 */
export const getSetupFeeName = plan => {
  var _plan$pricing2;
  return (_plan$pricing2 = plan.pricing) == null || (_plan$pricing2 = _plan$pricing2.feeConfigs) == null || (_plan$pricing2 = _plan$pricing2[0]) == null || (_plan$pricing2 = _plan$pricing2.fee) == null ? void 0 : _plan$pricing2.name;
};

/**
 * @returns setup fee amount or undefined if setup fee doesn't exist
 */
export const getSetupFeeAmount = plan => {
  var _plan$pricing3;
  const amount = (_plan$pricing3 = plan.pricing) == null || (_plan$pricing3 = _plan$pricing3.feeConfigs) == null || (_plan$pricing3 = _plan$pricing3[0]) == null || (_plan$pricing3 = _plan$pricing3.fee) == null ? void 0 : _plan$pricing3.amount;
  return amount ? amount : undefined;
};
//# sourceMappingURL=setup-fee.js.map